import useTranslations from '@/i18n/useTranslations';
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";
import Text from "@/shared-components/text/components/Text";

import "./styles/PopUpDrafts.css";

const PopUpDrafts = ({ open, close, DraftsList }) => {
  const t = useTranslations('common.profile.popups.drafts');
  const handleBackgroundClick = (event) => {
    const card = event.currentTarget.querySelector('.generic-popup__card');
    if (card && card.contains(event.target)) {
      return;
    }

    if (typeof close === 'function') {
      close();
    }
  };

  return (
    <GenericPopup
      open={open}
      className="pop-up-drafts remove-scrollbar"
      darkerBlur
      opacity
      onBackgroundClick={handleBackgroundClick}
    >
      <div className="pop-up-drafts__header">
        <Text className="pop-up-drafts__header-text font-size-large">
          {t('title')}
        </Text>
        <XIcon className="pop-up-drafts__header-Xicon" onClick={close} />
      </div>
      <div className="pop-up-drafts__list remove-scrollbar">
        <DraftsList variant="popup" />
      </div>
    </GenericPopup>
  );
};

export default PopUpDrafts;
